<template>
  <ul class="c-list--checkup">
    <li class="c-list--checkup__item">
      <span class="c-list--checkup__label judgement">判定</span>
      <div class="c-list--checkup__content">
        <p v-if="!hasError">
          あなたのWebページは非推奨タグが使用されていません。
        </p>
        <p v-else>
          あなたのWebページは非推奨なタグが使用されています。
        </p>
      </div>
    </li>
    <li
      v-if="Object.keys(deprecatedHtmlTags).length"
      class="c-list--checkup__item"
    >
      <span class="c-list--checkup__label detail">内容</span>
      <div class="c-list--checkup__content">
        <ul class="c-list--disc">
          <li v-for="(value, name, index) in deprecatedHtmlTags" :key="index">
            {{ name }}タグ: {{ value }}個
          </li>
        </ul>
      </div>
    </li>
    <li v-if="hasError" class="c-list--checkup__item">
      <span class="c-list--checkup__label hint">ヒント</span>
      <div class="c-list--checkup__content">
        <ol class="c-list--decimal">
          <li>非推奨タグの内容を上記にて確認をする。</li>
          <li>対象となるタグをコピーする。</li>
          <li>
            HPのソース（HTML）から該当箇所を確認し、対象のタグを削除する。
          </li>
        </ol>
      </div>
    </li>
  </ul>
</template>

<script>
export default {
  props: {
    detail: {
      type: Object,
      required: true
    },
    hasError: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    deprecatedHtmlTags() {
      return Object.keys(this.detail.tags)
        .filter(e => this.detail.tags[e] >= 1)
        .reduce((obj, key) => {
          obj[key] = this.detail.tags[key];
          return obj;
        }, {});
    }
  }
};
</script>
